import React, { useContext } from "react";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const OrientationConfirmation = ({ showScheduleOrientation }) => {
  const adminRegistration = useContext(AdminRegistrationContext);
  const { registration, updateProcessingLevel, registrationStatusUpdate } =
    adminRegistration;
  const {
    _id,
    orientationScheduled,
    orientationType,
    orientationTime,
    orientationLink,
  } = registration;

  const virtualOrientation = orientationType === "VIRTUAL";
  return (
    <div className="orientation-confirmation">
      <p>
        <strong>Orientation Type:</strong>
        <i>{`${virtualOrientation ? "Virtual" : "In-Person"}`}</i>
      </p>
      <p>
        <strong>
          {`${virtualOrientation ? `Orientation Link` : "Orientation Date"}:`}
        </strong>
        <i>{`${virtualOrientation ? orientationLink : orientationTime}`}</i>
      </p>
      <div className="select-btns">
        <div
          className="btn btn-llac-dark-green"
          onClick={() =>
            registrationStatusUpdate(
              {
                status: "Orientation Scheduled",
                progressLevel: 2,
                processingLevel: 2,
              },
              "POST",
              _id
            )
          }
        >
          Confirm
        </div>
        <div
          className="btn btn-llac-dark-green"
          onClick={() => showScheduleOrientation(true)}
        >
          Reschedule
        </div>
      </div>
    </div>
  );
};

export default OrientationConfirmation;
